<template>
  <div class="media-stream flex flex-col justify-center items-center">
    <div class="options py-10">
      <a
        class="font-bold py-2 px-4 rounded"
        :class="{
          'bg-blue-500': action == 'join',
          'text-white': action == 'join',
          'bg-blue-500': action == 'join'
        }"
        @click="action = 'join'"
      >
        <span>Join</span>
      </a>
      <a
        class="font-bold py-2 px-4 rounded"
        :class="{
          'bg-green-500': action == 'create',
          'text-white': action == 'create',
          'bg-green-500': action == 'create'
        }"
        @click="action = 'create'"
      >
        <span>Create</span>
      </a>
    </div>
    <div class="join flex-1" v-if="action == 'join'">
      <form ref="join-form" @submit.prevent="joinRoom()">
        <div class="">
          <label for="room-key" class="block text-gray-700 text-sm font-bold mb-2">
            Room Key
          </label>
          <input
            id="room-key"
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name="room-key"
            v-model="roomKey"
            required
          >
        </div>
        <div class="">
          <button
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 w-full rounded mt-3"
            type="submit"
            name="create-room"
          >
            Join
          </button>
        </div>
      </form>
    </div>
    <div class="create flex-1" v-else-if="action == 'create'">
      <form ref="create-form" @submit.prevent="createRoom()">
        <div class="flex items-center justify-start">
          <div class=" flex items-center justify-center">
            <input
              id="room-type-stream"
              class="form-radio"
              type="radio"
              name="room-type"
              value="stream"
              v-model="roomType"
            >
            <label for="room-type-stream" class="text-gray-700 font-bold ml-1">
              Stream
            </label>
          </div>
          <!-- <div class="">
            <input
              id="room-type-conference"
              class="form-radio"
              type="radio"
              name="room-type"
              value="conference"
              v-model="roomType"
            >
            <label for="room-type-conference" class="text-gray-700 font-bold ml-2">
              Conference
            </label>
          </div> -->
        </div>
        <select
          class="mt-3 w-64	block appearance-none bg-gray-200 border border-gray-200 text-gray-700 py-2 px-3 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          v-model="deviceId"
          v-if="!isMobile"
          required
        >
          <option :value="null" selected disabled>Device</option>
          <option
            v-for="(device, key) in devices.filter(d => d.kind.includes('video'))"
            :key="`device-${key}`"
            :value="device.deviceId"
          >
            {{ device.label || `Device ${key + 1}` }}
          </option>
        </select>
        <div class="flex flex-col justify-center items-center mt-2" v-else>
          <div class="">
            <label class="text-gray-700 font-bold ml-1">Camera option</label>
          </div>
          <div class="flex justify-center items-center flex-wrap">
            <div class="mobile-device flex items-center justify-center">
              <input
                id="room-type-stream-user"
                class="form-radio"
                type="radio"
                name="room-type"
                value="user"
                v-model="deviceId"
              >
              <label for="room-type-stream-user" class="text-gray-700 font-bold ml-1">
                User
              </label>
            </div>
            <div class="mobile-device flex items-center justify-center">
              <input
                id="room-type-stream-environment"
                class="form-radio"
                type="radio"
                name="room-type"
                value="environment"
                v-model="deviceId"
              >
              <label for="room-type-stream-environment" class="text-gray-700 font-bold ml-1">
                Environment
              </label>
            </div>
            <div class="mobile-device flex items-center justify-center">
              <input
                id="room-type-stream-left"
                class="form-radio"
                type="radio"
                name="room-type"
                value="left"
                v-model="deviceId"
              >
              <label for="room-type-stream-left" class="text-gray-700 font-bold ml-1">
                Left
              </label>
            </div>
            <div class="mobile-device flex items-center justify-center">
              <input
                id="room-type-stream-right"
                class="form-radio"
                type="radio"
                name="room-type"
                value="right"
                v-model="deviceId"
              >
              <label for="room-type-stream-right" class="text-gray-700 font-bold ml-1">
                Right
              </label>
            </div>
          </div>
        </div>
        <div class="">
          <button
            class="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 w-full rounded mt-3"
            type="submit"
            name="create-room"
          >
            Create
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'MediaStream',
  data () {
    return {
      action: 'join',
      deviceId: null,
      devices: [],
    }
  },
  computed: {
    ...mapGetters({
      type: 'mediaStream/getType',
      key: 'mediaStream/getRoomKey',
      isMobile: 'isMobile'
    }),
    roomType: {
      get () {
        return this.type
      },
      set (value) {
        this.setType(value)
      }
    },
    roomKey: {
      get () {
        return this.key
      },
      set (value) {
        this.setRoomKey(value)
      }
    }
  },
  methods: {
    ...mapMutations({
      setCreate: 'mediaStream/setCreate',
      setType: 'mediaStream/setType',
      setRoomKey: 'mediaStream/setRoomKey',
      setDevice: 'mediaStream/setDevice'
    }),
    async getDevices () {
      try {
        this.devices = await navigator.mediaDevices.enumerateDevices()
      } catch (error) {
        console.warn(error)
      }
    },
    createRoom () {
      if (!this.$refs['create-form'].reportValidity())
        return

      if (!this.deviceId)
        return

      this.setDevice(this.deviceId)
      this.setCreate(true)
      this.$router.push({ name:'MediaStreamRoom', params: { room: Math.random().toString(36).substr(2, 9) } })
    },
    joinRoom () {
      if (this.key) {
        this.setCreate(false)
        this.$router.push({ name:'MediaStreamRoom', params: { room: this.key } })
      }
    }
  },
  beforeMount () {
    this.getDevices()
  },
}
</script>

<style lang="scss">
.media-stream {
  .options {
    a {
      cursor: pointer;
      span {
        margin: 4px 8px;
      }
    }
  }
}

.mobile-device:not(:last-child) {
  margin-right: .75em;
}
</style>
